import { useEffect, useState } from "react";
import { sessionService } from "@services/sessionService";

export const useRestoreSession = (): { isLoading: boolean } => {
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    let active = true;

    sessionService.restore().finally(() => {
      if (active) {
        setIsLoading(false);
      }
    });

    return () => {
      active = false;
    };
  }, []);

  return { isLoading };
};
